import { useEffect, useRef, useState } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { setCustomNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview';
import { pointerOutsideOfPreview } from '@atlaskit/pragmatic-drag-and-drop/element/pointer-outside-of-preview';

export const useDraggableCard = ({ cardId, columnId, index, canDrag = true, leadItem = null }) => {
  const elementRef = useRef(null);
  const [dragState, setDragState] = useState('idle'); // 'idle' | 'dragging'

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    // Don't set up draggable if card is locked
    if (!canDrag) {
      return;
    }

    const cleanup = draggable({
      element,
      getInitialData: () => ({
        type: 'card',
        cardId,
        columnId,
        index,
        leadItem, // Include full lead item for interception logic
      }),
      onDragStart: () => setDragState('dragging'),
      onDrop: () => setDragState('idle'),
      onGenerateDragPreview: ({ nativeSetDragImage }) => {
        setCustomNativeDragPreview({
          nativeSetDragImage,
          getOffset: pointerOutsideOfPreview({ x: '18px', y: '18px' }),
          render: ({ container }) => {
            const clone = element.cloneNode(true);
            clone.style.width = `${element.offsetWidth}px`;
            clone.style.transform = 'rotate(4deg)';
            clone.style.opacity = '0.9';
            clone.style.boxShadow = '0 12px 40px rgba(0,0,0,0.25)';
            container.appendChild(clone);
          },
        });
      },
    });

    return cleanup;
  }, [cardId, columnId, index, canDrag, leadItem]);

  return {
    elementRef,
    isDragging: dragState === 'dragging',
  };
};
